import React from "react";
import logo from "../images/logo.png";
const PdfLogo = () => {
  return (
    <img
      src={logo}
      style={{ width: "140px", height: "100px", objectFit: "contain" }}
    />
  );
};

export default PdfLogo;
